export default "__VITE_ASSET__BizgrXlu__"